require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./jobs-at-code-fellows.json") })
        }
      }, "path---jobs-at-code-fellows");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---jobs-at-code-fellows!./.cache/json/jobs-at-code-fellows.json
// module id = 1196
// module chunks = 231608221292675